import { isDefined } from "Utils/functions";

export const isPartialAddressValid = (partialAddress?: string): boolean =>
  isDefined(partialAddress) && partialAddress.length > 0;
